class CurrentsApiService {
  constructor() {
    this.apiKey = null;
    this.baseUrl = 'https://api.currentsapi.services/v1';
    this.proxyUrl = '/api/currents';
    this.serverUrl = 'http://localhost:3001';
  }

  init(apiKey) {
    this.apiKey = apiKey;
    
    // Получаем URL сервера из NewsService, если он был определен
    try {
      const NewsService = require('./NewsService').default;
      if (NewsService.serverUrl) {
        this.serverUrl = NewsService.serverUrl;
      }
    } catch (e) {
      console.log('Не удалось получить URL сервера из NewsService');
    }
  }

  async getNews(keywords, language, hoursAgo) {
    if (!this.apiKey) {
      throw new Error('Currents API Key не установлен');
    }

    try {
      console.log(`Получение новостей из Currents API для ключевых слов: ${keywords.join(', ')}`);
      
      // Формируем дату для поиска (текущая дата минус указанное количество часов)
      const now = new Date();
      const startDate = new Date(now.getTime() - hoursAgo * 60 * 60 * 1000);
      
      // Форматируем дату в формат ISO
      const startDateStr = startDate.toISOString();
      
      // Формируем параметры запроса
      const params = {
        apiKey: this.apiKey,
        language: this.mapLanguage(language),
        start_date: startDateStr,
        keywords: keywords.join(' OR '),
        limit: 20
      };
      
      // Полный URL для запроса
      const url = `${this.serverUrl}${this.proxyUrl}`;
      console.log(`Отправка запроса к Currents API через прокси: ${url}`);
      
      // Выполняем запрос через прокси
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Ошибка API: ${response.status} ${response.statusText} - ${errorText}`);
      }
      
      const data = await response.json();
      
      if (!data.news || !Array.isArray(data.news)) {
        console.warn('Currents API вернул неожиданный формат данных:', data);
        return [];
      }
      
      // Преобразуем данные в нужный формат
      const formattedResults = data.news.map(article => ({
        title: article.title,
        description: article.description || '',
        url: article.url,
        image: article.image || null,
        publishedAt: article.published,
        source: article.source || 'Currents API',
        apiSource: 'currents'
      }));
      
      return formattedResults;
    } catch (error) {
      console.error('Ошибка при получении новостей из Currents API:', error);
      
      // Пробуем прямой запрос как запасной вариант
      try {
        console.log('Пробуем прямой запрос к Currents API...');
        return await this.getNewsDirect(keywords, language, hoursAgo);
      } catch (directError) {
        console.error('Ошибка при прямом запросе к Currents API:', directError);
        return [];
      }
    }
  }
  
  // Метод для прямого запроса к Currents API (может не работать из-за CORS)
  async getNewsDirect(keywords, language, hoursAgo) {
    if (!this.apiKey) {
      throw new Error('Currents API Key не установлен');
    }
    
    try {
      console.log(`Прямой запрос к Currents API для ключевых слов: ${keywords.join(', ')}`);
      
      // Формируем дату для поиска
      const now = new Date();
      const startDate = new Date(now.getTime() - hoursAgo * 60 * 60 * 1000);
      const startDateStr = startDate.toISOString();
      
      // Формируем параметры запроса
      const params = new URLSearchParams({
        apiKey: this.apiKey,
        language: this.mapLanguage(language),
        start_date: startDateStr,
        keywords: keywords.join(' OR '),
        limit: 20
      });
      
      const url = `${this.baseUrl}/search?${params.toString()}`;
      console.log('Прямой запрос к Currents API:', url);
      
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`Ошибка API: ${response.status} ${response.statusText}`);
      }
      
      const data = await response.json();
      
      if (!data.news || !Array.isArray(data.news)) {
        return [];
      }
      
      // Преобразуем данные в нужный формат
      const formattedResults = data.news.map(article => ({
        title: article.title,
        description: article.description || '',
        url: article.url,
        image: article.image || null,
        publishedAt: article.published,
        source: article.source || 'Currents API',
        apiSource: 'currents'
      }));
      
      return formattedResults;
    } catch (error) {
      console.error('Ошибка при прямом запросе к Currents API:', error);
      return [];
    }
  }
  
  // Преобразование кода языка в формат, понятный для Currents API
  mapLanguage(language) {
    const languageMap = {
      'ru': 'ru',
      'en': 'en',
      'de': 'de',
      'fr': 'fr',
      'es': 'es',
      'it': 'it',
      'pt': 'pt',
      'nl': 'nl',
      'ar': 'ar',
      'zh': 'zh'
    };
    
    return languageMap[language] || 'en';
  }
}

export default new CurrentsApiService();